export default {
  "http://localhost:3000": "",
  "https://connectedbuildings-dev.retail-azure.js-devops.co.uk":
    "53a815e8-4c1e-45fa-82c3-168a5f79155b",
  "https://connectedbuildings-stg.retail-azure.js-devops.co.uk":
    "4d923cba-1d23-45b0-9977-307948e054d2",
  "https://connectedbuildings-prod.retail-azure.js-devops.co.uk":
    "ed3c3251-5a45-492b-b147-a95c72689b56",
  "https://bms.sainsburys.co.uk": "ed3c3251-5a45-492b-b147-a95c72689b56"
};
